import React, { useEffect, useMemo, useCallback } from 'react'
import { Container, TitleBar, Label } from '@sencha/ext-modern'

import { useInstData } from 'tyan/public/hooks'
import TyanGrid from 'tyan/public/components/Form/Block/TyanGrid'

/**
 * props.show:
 * {
 * 	title, 		// 默认 menu._title
 * 	interval, 	// 取数间隔时间，默认5秒
 * 	columns, 			// 用于show的定义
 * }
 */
const Show = props => {
	const { config, onClose, doFetchManagerData } = props

	const { me, setState, me: { state: { list, pageNum, total } } } = useInstData(props, useMemo(() => ({
		state: { pageNum: 1, total: 0 }
	}), []))

	const { show, title, numPerPage, interval, columns } = useMemo(() => {
		const show = config.show === true ? {} : config.show
		const title = show.title || (Tyan.menus.allPaths[location.hash.substring(1)] || {})._title
		const numPerPage = /* show.numPerPage ||  */Tyan.psnCfg.numPerPage
		const interval = show.interval || 5000
		const columns = show.columns || config.columns
		return { show, title, numPerPage, interval, columns }
	}, [])

	const totalPages = Math.ceil(total / numPerPage) || 1

	const doGetData = useCallback((page) => {
		const { pageNum, total } = me.state
		// console.log('debug:', page, pageNum, Math.ceil(total / numPerPage))
		page = page || (pageNum >= Math.ceil(total / numPerPage) ? 1 : pageNum + 1)

		doFetchManagerData({
			columns: config.columns, exportColumns: show.columns, pageNum: page, numPerPage, showFetchSpinner: false,
			onEnd: ({ errorMessage, list, pageNum, total }) => {
				if (me.unmounted) return

				if (errorMessage) {
					Ext.toast(errorMessage)
					me.idGetData = setTimeout(() => doGetData(page))
				} else {
					setState({ list, pageNum, total })
					// console.log('get data:', pageNum, total, numPerPage, total / numPerPage)
					me.idGetData = setTimeout(doGetData, interval)
				}
			}
		})

		// const setData = list => {
		// 	list.forEach(data => (delete data.id, cols.forEach(col => col.field && col.field !== col.name && delete data[col.field])))
		// 	calcData && (list = list.map(calcData))
		// 	!me.unmounted && setState({ data: list })
		// }
		// onGetData ? onGetData(pivot.columns, setData) : onClose && onClose()
	}, [])

	const listeners = useMemo(() => ({
		fullscreenchange: {
			element: 'element',
			fn: () => document.fullscreenElement
				? me.container.element.dom.style.cursor = 'none'
				: onClose()
		},
		fullscreenerror: {
			element: 'element',
			fn: () => {
				Ext.toast('投屏失败')
				console.log('投屏操作失败，请与系统管理员联系')
			}
		}
	}), [])

	useEffect(() => {
		me.container.element.dom.requestFullscreen()
		doGetData(1)
		return () => {
			if (me.trGetData) {
				clearTimeout(me.idGetData)
				delete me.idGetData
			}
		}
	}, [])

	return <Container listeners={listeners}
		ref={ref => ref && ref.cmp !== me.container && (me.container = ref.cmp)}
		layout='fit' margin={"5 10 10 10"}
		shadow
	>
		<TitleBar noLocale docked="top" shadow style={{ zIndex: 2 }} title={`　${title}`}>
			<Label align='right' noLocale
				html={`<div>${pageNum} / ${totalPages} `}
			/>
		</TitleBar>
		<TyanGrid list={list} columns={columns} selectable={false} />
	</Container>
}

export default Show